import { z } from "zod";
import { PublicUserSchema } from "../../models/user.schema";

export const DecodedIdTokenSchema = z.object({
  aud: z.string(),
  auth_time: z.number(),
  email: z.string().optional(),
  email_verified: z.boolean().optional(),
  exp: z.number(),
  firebase: z.object({
    // identities: z.record(z.any()),
    sign_in_provider: z.string(),
    sign_in_second_factor: z.string().optional(),
    second_factor_identifier: z.string().optional(),
    tenant: z.string().optional(),
  }),
  iat: z.number(),
  iss: z.string(),
  phone_number: z.string().optional(),
  picture: z.string().optional(),
  sub: z.string(),
  uid: z.string(),
});

export const UserControllerResponseSchema = {
  getPublicUser: PublicUserSchema.nullable(),

  getUserTest: DecodedIdTokenSchema.optional(),
};
